<form class="needs-validation" [formGroup]="myForm" novalidate>
   <ng-container *ngIf="!group">
      <p class="bold pad-left">Provider Name</p>
      <div class="form-row pad-left">
         <div class="col-md-5 col-5">
            <label class="no-bold" for="name">First Name</label>
            <input type="text" class="form-control" id="name" formControlName="name" required>
            <p class="err" *ngIf="myForm.controls['name'].hasError('required') && myForm.controls['name'].touched">
               First Name is required
            </p>
            <span class="err no-pad" *ngIf="myForm.controls['name'].hasError('pattern')">
               Invalid character 
            </span> 
         </div>
         <div class="col-2 col-md-1 ">
            <label class="no-bold lb" 
               tooltip="Middle Initial (optional)" 
               placement="top" 
               for="middleInitial"
               #tooltip="bs-tooltip"
               (mouseenter)="tooltip.show()"
               triggers="">
               M.I.
            </label>
            <input type="text" class="form-control" 
               id="middleInitial" 
               formControlName="middleInitial" 
               maxlength="1"
               (focus)="tooltip.show()"
               (blur)="tooltip.hide()"
               >
            <span class="err no-pad abs" *ngIf="myForm.controls['middleInitial'].hasError('pattern')">
               Invalid character 
            </span>
         </div>
         <div class="col-md-5 col-5 ">
            <label class="no-bold" for="lastName">Last Name</label>
            <input type="text" class="form-control" id="lastName" formControlName ="lastName" required>
            <p class="err" *ngIf="myForm.controls['lastName'].hasError('required') && myForm.controls['lastName'].touched">
               Last Name is required
            </p>
            <p class="err no-pad" *ngIf="myForm.controls['lastName'].hasError('pattern')">
               Invalid character 
            </p>
         </div>
      </div>
   </ng-container>
   <ng-container *ngIf="group">
      <div class="form-row pad-left">
         <div class="col-md-8 mb-3">
            <label class="bold no-pad" for="name">Dental Practice Name</label>
            <input type="text" class="form-control " id="name" formControlName = "name" required>
            <p class="err" *ngIf="myForm.controls['name'].hasError('required') && myForm.controls['name'].touched">
               Practice Name is required
            </p>
            <p class="err no-pad" *ngIf="myForm.controls['name'].hasError('pattern')">
               Invalid character 
            </p>
         </div>
      </div>
   </ng-container>
   <fieldset class = "pad-left">
      <legend class="bold no-pad" >Identification Type</legend>
      <!-- <p class="bold ">Identification Type</p> -->
      <p class="no-pad ">We need to match one of these to our records in order to process your request.</p>
      <div class="btn-group small-pad">
         <label
         class="btn btn-default radio-label"
         *ngFor="let item of radio | slice:0:radioSize ; index as i;"
         [ngClass]="{ active: radio[i].val, focus: radio[i].focus }" 
         >
         <input 
         type="radio"
         name="idType" 
         value = {{item.value}}
         formControlName="idType"
         (change)="handleRadioChange($event, i);onIdChange($event)"
         (blur)="handleRadioBlur($event, i)"
         (focus)="handleRadioFocus($event, i)"
         role="radio"
         /> 
         {{ item.label}}
         
         </label>
      </div>
   </fieldset>
   <div class="col-md-7 mb-3">
      <p *ngIf="myForm.value.idType === 'NPI'">
         <label class="block no-pad" for="NPI">NPI Number</label>
      </p>
      <p *ngIf="myForm.value.idType === 'taxID'">
         <label class="block no-pad" for="taxID">Tax ID</label>
      </p>
      <p *ngIf="myForm.value.idType === 'providerID' && !new">
         <label class="block no-pad" for="providerID">UCD Provider ID</label>
      </p>
      <input *ngIf="myForm.value.idType === 'NPI'" 
               type = text class="form-control left-margin" 
               placeholder="10 digits" 
               maxlength="10" 
               id="NPI" formControlName='NPI' 
               (change)="onIdChange($event)" 
               (blur)="onIdChange($event)">

      <input *ngIf="myForm.value.idType === 'taxID'" 
               type=text class="form-control left-margin" 
               placeholder="9 digits" 
               maxlength="9" 
               id="taxID"
               formControlName='taxID' 
               (change)="onIdChange($event)" 
               (blur)="onIdChange($event)"> 

      <input *ngIf="myForm.value.idType === 'providerID' && !new" 
               type = text class="form-control left-margin" 
               placeholder="9 digits" 
               maxlength="9" id="providerID" 
               formControlName='providerID'
                (change)="onIdChange($event)" 
                (blur)="onIdChange($event)">

      <p class="err pad-left" *ngIf="myForm.controls[idType].hasError('required') && myForm.controls[idType].touched">
          ID is required
      </p>
      <p class="err pad-left" *ngIf="myForm.controls['NPI'].hasError('required') && myForm.controls['idType'].touched && new && !group && idType == 'taxID'">
         NPI is required
      </p>
      <p class="err pad-left" *ngIf="myForm.controls[idType].hasError('idValidator')">
         Invalid character 
      </p>
   </div>
   <div class="dropdown">
      <div class="col-md-7 mb-3">
         <label for="country">Country</label>
         <select class="custom-select" id="country" formControlName="country" required
                  (change)="onIdChange($event)">
            <option *ngFor="let country of countries | keyvalue: valueAscOrder"
                     value="{{country.key}}">{{country.value | capital}}</option>
         </select>
         <p class="err" *ngIf="myForm.controls['country'].hasError('required') && myForm.controls['country'].touched">
            Country is required
         </p>
      </div>
   </div>
   <div class="dropdown" *ngIf="myForm.controls['country'].value === 'US'">
      <div class="col-md-7 mb-3">
         <label for="state">Practicing State(s)</label>
         <select class="custom-select" id="state" formControlName="state" (click)="myForm.controls['state'].markAsTouched();">
            <option selected value="">- Select -</option>
            <option *ngFor="let state of states | keyvalue: valueAscOrder" value="{{state.key}}">
               {{ state.value | capital }}
            </option>
         </select>
         <p class="err" *ngIf="myForm.controls['state'].hasError('stateValid') && myForm.controls['state'].touched">
            State is required
         </p>
         <button type="button" (click)="addState(myForm.controls['state'].value)" [disabled]="!myForm.controls['state'].value" class="btn btn-light btn-sm blue-cir" >Add State</button>
         <div *ngIf="statesArr.length == 0" id="no-states">
            <p id="light">No states added yet</p>
         </div>
         <div id="no-states" *ngFor="let state of statesArr; let i = index">
            <p>
               {{states[state] | capital}}
               <span tooltip="Remove" placement="right" (click)="removeState(i)" class="delete">X</span>
            </p>
         </div>
         <p class="col-md-7 mb-3 bold pad" *ngIf="statesArr.length > 0">Is this request part of Medicaid/CHIP?</p>
         <div class="btn-group" *ngIf="statesArr.length > 0 ">
            <label 
            class="btn btn-default radio-label left-margin"
            *ngFor="let item of gateway; index as i"
            [ngClass]="{ active: gateway[i].val, focus: gateway[i].focus, red: myForm.controls['gateway'].hasError('required'), notred: myForm.controls['gateway'].valid }"
            >
            <input
            type="radio"
            formControlName ="gateway"
            name="gateway" 
            value = {{item.value}}
            (change)="handleGatewayChange($event, i)"
            (blur)="handleGatewayBlur($event, i)"
            role="button"
            /> {{ item.label}}
         </label>
      </div>
         <span class="err" *ngIf="myForm.controls['gateway'].hasError('required')">
            Medicaid/CHIP is required
         </span>
      </div>
   </div>
</form>

